import React, { useEffect, useState, useRef, useCallback } from 'react'
import useApp from 'hooks/useApp'
import { Button, LayerBottom } from 'components'
import styles from 'views/home/index.module.css'
import Graph from 'library/Graph'
import Snap from 'snapsvg-cjs'
import useEffectAvailable from 'hooks/useEffectAvailable'
import { useNavigate, useLocation } from 'react-router-dom'
import Lib from 'library'

const DataDetail = () => {

	const App = useApp()
	const navigate = useNavigate()
	const location = useLocation()

	const mounted = useRef()

	const [tabList, setTabList] = useState(0)
	const [dataOpen, setDataOpen] = useState()
	const [sno, setSno] = useState(location.state?.sno)
	const [data, setData] = useState(location.state?.data)	//해당 증명서 상세 데이터

	const { shareData } = useLocation()	//공유한 증명서 데이터 받아오기

	useEffect(() => {
		mounted.current = true
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: undefined
		})

		App.setShowNav(false)
		App.setMainClass("white")

		console.log({ shareData })
		console.log({ data })
		console.log(location.state)

		// 마이데이터 탭 포커싱 처리. 20221028
		if (Lib.isNotNull(data) && Lib.isNotNull(data.mdataDtl)) {
			if (data.mdataDtl.acntBlncAmt !== null || data.mdataDtl.acntLoanBlncAmt !== null || data.mdataDtl.acntInvstEvalAmt !== null) {
				setTabList(0)
			} else if (data.mdataDtl.cardPayExpAmt !== null || data.mdataDtl.cardPrpymBlncAmt !== null || data.mdataDtl.cardLoanBlncAmt !== null) {
				setTabList(1)
			} else if (data.mdataDtl.insuMthAvrgPymnt !== null || data.mdataDtl.insuLoanBlncAmt !== null) {
				setTabList(2)
			} else if (data.mdataDtl.sabInvstEvalAmt !== null) {
				setTabList(3)
			} else if (data.mdataDtl.ebankPayAmt !== null || data.mdataDtl.ebankPayBlncAmt !== null) {
				setTabList(4)
			} else if (data.mdataDtl.cmnctBlngAmt !== null) {
				setTabList(5)
			} else if (data.mdataDtl.irpBankAcntBlncAmt !== null || data.mdataDtl.irpInsuAcntBlncAmt !== null || data.mdataDtl.irpSabAcntBlncAmt !== null) {
				setTabList(6)
			} else if (data.mdataDtl.gnteeInsuTotalPymntAmt !== null) {
				setTabList(7)	
			} else if (data.mdataDtl.instlFincLoanBlncAmt !== null) {
				setTabList(8)
			} else if (data.mdataDtl.bondLoanBlncAmt !== null) {
				setTabList(9)
			} else if (data.mdataDtl.p2pLoanBlncAmt !== null) {
				setTabList(10)
			}
		}

		return () => mounted.current = false
	}, [])


	return (
		<div className="page">
			<div className="shadow">
				<div className="padding pt_10">
					<AlarmComponent detail={data} />
					<div className="flex-justify_between mt_30">

						<h4>{`${data?.mbNm}님의`}<br /><strong>데이터 증명서</strong></h4>
						<span style={{ color: "#999", fontWeight: 500 }}>일련번호 No. {sno}</span>
					</div>
				</div>
			</div>

			{/* 신용정보 */}
			{data?.crdtDtl &&
				<div className="shadow">
					<div className={`${dataOpen === 0 ? "active" : ""} accordion-title flex-justify_between align_center padding`}
						onClick={() => {
							if (dataOpen === 0) {
								setDataOpen()
							} else {
								setDataOpen(0)
							}
						}}>
						<h3>신용정보</h3>
						<i className="icon icon_accordion_arrow" />
					</div>
					<div className="accordion-content padding pt_0">
						<p className={styles["info-title"]}>
							{`${data?.mbNm}`}님의 점수는 <strong className="text-blue">{data.crdtDtl?.score}</strong>으로<br />
							<strong>상위 {data.crdtDtl?.rt}%</strong>에 있네요!
						</p>

						{/* 그래프 영역 */}
						<div style={{ width: "22rem", height: "20rem", margin: "0 auto" }}>
							{/* {dataOpen === 0 && detailView &&
								sno ?
								<MainGraph data={location.state?.crdtDtl?.score} crdtRt={location.state?.crdtDtl?.rt} score={location.state?.crdtDtl?.score} />
								:
								<MainGraph data={detailView?.crdtDtl?.score} crdtRt={detailView?.crdtDtl?.rt} score={detailView?.crdtDtl?.score} />
							} */}
							{dataOpen === 0 && sno && <MainGraph data={data.crdtDtl?.score} crdtRt={data.crdtDtl?.rt} score={data.crdtDtl?.score} />}
						</div>

						<hr className="my_40" />

						<p className={`${styles["info-sub-title"]} mt_40`}>
							{data.crdtDtl?.ageGrp}대 평균 보다 {`${data?.mbNm}`}님의<br />점수가
							{data?.crdtDtl &&
								data.crdtDtl.score - data.crdtDtl.ageGrpScore >= 0 ?
								<strong className="text-blue">&nbsp;{data?.crdtDtl && data.crdtDtl.score - data.crdtDtl.ageGrpScore}점 더 높아요!</strong>
								:
								<strong className="text-blue">&nbsp;{data?.crdtDtl && data.crdtDtl.ageGrpScore - data.crdtDtl.score}점 더 낮아요!</strong>
							}
						</p>

						{data.crdtDtl?.score === 0 ?
							<div className="mt_30 pb_50 progress-wrap">
								<span className="flex-shrink_0">{data.crdtDtl?.ageGrp}대</span>ageGrp
								<div className="data-progress flex--item_1 ml_15">
									<div className="progress" style={{ width: 0 }}>
										<div className="txt">
											<span className="ml_10" style={{ color: "#999", whiteSpace: "nowrap" }}>나<span className="ml_5" style={{ color: "#57a7fb" }}>0점</span></span>
										</div>
									</div>
									<span className="floating-num" style={{ left: (data.crdtDtl?.ageGrpScore / 1000) * 100 + '%' }}>평균 {data.crdtDtl?.ageGrpScore}점</span>
								</div>
							</div>
							: data.crdtDtl?.score > 0 &&
							<div className="mt_30 pb_50 progress-wrap">
								<span className="flex-shrink_0">{data.crdtDtl?.ageGrp}대</span>
								<div className="data-progress flex--item_1 ml_15">
									<div className="progress" style={{ width: (data.crdtDtl?.score / 1000) * 100 + '%' }}>
										<div className="txt">
											<span>나</span>
											<span>{data.crdtDtl?.score}점</span>
										</div>
									</div>
									<span className="floating-num" style={{ left: (data.crdtDtl?.ageGrpScore / 1000) * 100 + '%' }}>평균 {data.crdtDtl?.ageGrpScore}점</span>
								</div>
							</div>
						}
					</div>
				</div>
			}

			{/* 마이데이터 */}
			{data?.mdataDtl &&
				<div className="shadow">
					<div className={`${dataOpen === 2 ? "active" : ""} accordion-title flex-justify_between align_center padding`}
						onClick={() => {
							if (dataOpen === 2) {
								setDataOpen()
							} else {
								setDataOpen(2)
							}
						}}>
						<h3>마이데이터</h3>
						<i className="icon icon_accordion_arrow" />
					</div>
					<div className="accordion-content">
						<div className="no-scroll" style={{ overflowX: "auto" }}>
							<ul className="tab-scroll">
								{data && (data.mdataDtl.acntBlncAmt !== null || data.mdataDtl.acntLoanBlncAmt !== null || data.mdataDtl.acntInvstEvalAmt !== null) &&
									<li onClick={() => setTabList(0)} className={tabList === 0 ? "active" : ""}>은행</li>
								}
								{data && (data.mdataDtl.cardPayExpAmt !== null || data.mdataDtl.cardPrpymBlncAmt !== null || data.mdataDtl.cardLoanBlncAmt !== null) &&
									<li onClick={() => setTabList(1)} className={tabList === 1 ? "active" : ""}>카드</li>
								}
								{data && (data.mdataDtl.insuMthAvrgPymnt !== null || data.mdataDtl.insuLoanBlncAmt !== null) &&
									<li onClick={() => setTabList(2)} className={tabList === 2 ? "active" : ""}>보험</li>
								}
								{data && data.mdataDtl.sabInvstEvalAmt !== null &&
									<li onClick={() => setTabList(3)} className={tabList === 3 ? "active" : ""}>증권</li>
								}
								{data && (data.mdataDtl.ebankPayAmt !== null || data.mdataDtl.ebankPayBlncAmt !== null) &&
									<li onClick={() => setTabList(4)} className={tabList === 4 ? "active" : ""}>전자금융</li>
								}
								{data && data.mdataDtl.cmnctBlngAmt !== null &&
									<li onClick={() => setTabList(5)} className={tabList === 5 ? "active" : ""}>통신</li>
								}
								{data && (data.mdataDtl.irpBankAcntBlncAmt !== null || data.mdataDtl.irpInsuAcntBlncAmt !== null || data.mdataDtl.irpSabAcntBlncAmt !== null) &&
									<li onClick={() => setTabList(6)} className={tabList === 6 ? "active" : ""}>개인IRP</li>
								}
								{data && data.mdataDtl.gnteeInsuTotalPymntAmt !== null &&
									<li onClick={() => setTabList(7)} className={tabList === 7 ? "active" : ""}>보증보험</li>
								}
								{data && data.mdataDtl.instlFincLoanBlncAmt !== null &&
									<li onClick={() => setTabList(8)} className={tabList === 8 ? "active" : ""}>할부금융</li>
								}
								{data && data.mdataDtl.bondLoanBlncAmt !== null &&
									<li onClick={() => setTabList(9)} className={tabList === 9 ? "active" : ""}>인수채권/대부</li>
								}
								{data && data.mdataDtl.p2pLoanBlncAmt !== null &&
									<li onClick={() => setTabList(10)} className={tabList === 10 ? "active" : ""}>P2P</li>
								}
								{/* <li onClick={() => setTabList(0)} className={tabList === 0 ? "active" : ""}>은행</li>
								<li onClick={() => setTabList(1)} className={tabList === 1 ? "active" : ""}>카드</li>
								<li onClick={() => setTabList(2)} className={tabList === 2 ? "active" : ""}>보험</li>
								<li onClick={() => setTabList(3)} className={tabList === 3 ? "active" : ""}>증권</li>
								<li onClick={() => setTabList(4)} className={tabList === 4 ? "active" : ""}>전자금융</li>
								<li onClick={() => setTabList(5)} className={tabList === 5 ? "active" : ""}>통신</li>
								<li onClick={() => setTabList(6)} className={tabList === 6 ? "active" : ""}>개인IRP</li>
								<li onClick={() => setTabList(7)} className={tabList === 7 ? "active" : ""}>보증보험</li>
								<li onClick={() => setTabList(8)} className={tabList === 8 ? "active" : ""}>할부금융</li>
								<li onClick={() => setTabList(9)} className={tabList === 9 ? "active" : ""}>인수채권/대부</li>
								<li onClick={() => setTabList(10)} className={tabList === 10 ? "active" : ""}>P2P</li> */}
							</ul>
						</div>

						{data?.mdataDtl && (

							tabList === 0 ? // 은행 Lib.isNull(blncAmtOrder)
								<ul className={`${styles["mydata-list"]} padding`}>
									<li>
										<span>계좌 잔액</span>
										<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(data.mdataDtl.acntBlncAmt) ? 0 : Lib.addComma(data.mdataDtl.acntBlncAmt)}</strong>원</span>
									</li>
									<li>
										<span>남은 대출금</span>
										<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(data.mdataDtl.acntLoanBlncAmt) ? 0 : Lib.addComma(data.mdataDtl.acntLoanBlncAmt)}</strong>원</span>
									</li>
									<li>
										<span>투자평가금액</span>
										<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(data.mdataDtl.acntInvstEvalAmt) ? 0 : Lib.addComma(data.mdataDtl.acntInvstEvalAmt)}</strong>원</span>
									</li>
								</ul>

								: tabList === 1 ? // 카드
									<ul className={`${styles["mydata-list"]} padding`}>
										<li>
											<span>{data.mdataDtl.cardPayMth}월 결제예정금액</span>
											<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(data.mdataDtl.cardPayExpAmt) ? 0 : Lib.addComma(data.mdataDtl.cardPayExpAmt)}</strong>원</span>
										</li>
										<li>
											<span>선불카드 총 잔액</span>
											<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(data.mdataDtl.cardPrpymBlncAmt) ? 0 : Lib.addComma(data.mdataDtl.cardPrpymBlncAmt)}</strong>원</span>
										</li>
										<li>
											<span>대출 잔액</span>
											<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(data.mdataDtl.cardLoanBlncAmt) ? 0 : Lib.addComma(data.mdataDtl.cardLoanBlncAmt)}</strong>원</span>
										</li>
									</ul>

									: tabList === 2 ? // 보험
										<ul className={`${styles["mydata-list"]} padding`}>
											<li>
												<span>월평균납입보험료</span>
												<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(data.mdataDtl.insuMthAvrgPymnt) ? 0 : Lib.addComma(data.mdataDtl.insuMthAvrgPymnt)}</strong>원</span>
											</li>
											<li>
												<span>남은 대출금</span>
												<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(data.mdataDtl.insuLoanBlncAmt) ? 0 : Lib.addComma(data.mdataDtl.insuLoanBlncAmt)}</strong>원</span>
											</li>
										</ul>

										: tabList === 3 ? // 증권
											<ul className={`${styles["mydata-list"]} padding`}>
												<li>
													<span>투자평가금액</span>
													<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(data.mdataDtl.sabInvstEvalAmt) ? 0 : Lib.addComma(data.mdataDtl.sabInvstEvalAmt)}</strong>원</span>
												</li>
											</ul>

											: tabList === 4 ? // 전자금융
												<ul className={`${styles["mydata-list"]} padding`}>
													<li>
														<span>{data.mdataDtl.ebankPayMth}월 결제 총액</span>
														<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(data.mdataDtl.ebankPayAmt) ? 0 : Lib.addComma(data.mdataDtl.ebankPayAmt)}</strong>원</span>
													</li>
													<li>
														<span>페이 총 잔액</span>
														<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(data.mdataDtl.ebankPayBlncAmt) ? 0 : Lib.addComma(data.mdataDtl.ebankPayBlncAmt)}</strong>원</span>
													</li>
												</ul>

												: tabList === 5 ? // 통신
													<ul className={`${styles["mydata-list"]} padding`}>
														<li>
															<span>{data.mdataDtl.cmnctBlngMth}월 청구금액</span>
															<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(data.mdataDtl.cmnctBlngAmt) ? 0 : Lib.addComma(data.mdataDtl.cmnctBlngAmt)}</strong>원</span>
														</li>
													</ul>

													: tabList === 6 ? // 개인IRP
														<ul className={`${styles["mydata-list"]} padding`}>
															<li>
																<span>은행 계좌 잔액</span>
																<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(data.mdataDtl.irpBankAcntBlncAmt) ? 0 : Lib.addComma(data.mdataDtl.irpBankAcntBlncAmt)}</strong>원</span>
															</li>
															<li>
																<span>보험 계좌 잔액</span>
																<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(data.mdataDtl.irpInsuAcntBlncAmt) ? 0 : Lib.addComma(data.mdataDtl.irpInsuAcntBlncAmt)}</strong>원</span>
															</li>
															<li>
																<span>증권 계좌 잔액</span>
																<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(data.mdataDtl.irpSabAcntBlncAmt) ? 0 : Lib.addComma(data.mdataDtl.irpSabAcntBlncAmt)}</strong>원</span>
															</li>
														</ul>

														: tabList === 7 ? // 보증보험
															<ul className={`${styles["mydata-list"]} padding`}>
																<li>
																	<span>총납입보험료</span>
																	<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(data.mdataDtl.gnteeInsuTotalPymntAmt) ? 0 : Lib.addComma(data.mdataDtl.gnteeInsuTotalPymntAmt)}</strong>원</span>
																</li>
															</ul>

															: tabList === 8 ? // 할부금융
																<ul className={`${styles["mydata-list"]} padding`}>
																	<li>
																		<span>대출잔액</span>
																		<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(data.mdataDtl.instlFincLoanBlncAmt) ? 0 : Lib.addComma(data.mdataDtl.instlFincLoanBlncAmt)}</strong>원</span>
																	</li>
																</ul>

																: tabList === 9 ? // 인수채권/대부
																	<ul className={`${styles["mydata-list"]} padding`}>
																		<li>
																			<span>대출잔액</span>
																			<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(data.mdataDtl.bondLoanBlncAmt) ? 0 : Lib.addComma(data.mdataDtl.bondLoanBlncAmt)}</strong>원</span>
																		</li>
																	</ul>

																	: tabList === 10 ? // P2P
																		<ul className={`${styles["mydata-list"]} padding`}>
																			<li>
																				<span>대출잔액</span>
																				<span className={styles.price}><strong className="text-blue mr_5">{Lib.isNull(data.mdataDtl.p2pLoanBlncAmt) ? 0 : Lib.addComma(data.mdataDtl.p2pLoanBlncAmt)}</strong>원</span>
																			</li>
																		</ul>
																		: null
						)}

					</div>
				</div>
			}

			<div className="padding">
				<p style={{ fontSize: "1.6rem" }}>이 증명서는 원본 내용과 틀림없음을 증명합니다.</p>
				<div className="text-align_center mt_40">
					<p style={{ color: "#666" }}>{Lib.dateFormat(data?.dt, ".")}<br />주식회사 핀테크(모니)</p>
				</div>
				<Button className="btn btn--big mt_40" onClick={() => navigate("/")}>증명서 닫기</Button>
			</div>
		</div>
	)
}

const AlarmComponent = ({ detail }) => {

	const [day, setDay] = useState();
	const [timeRender, setTimeRender] = useState();
	const [dis, setDis] = useState();
	const timer = useRef(null);
	const dt = detail?.avlDt

	const getDay = (dt, set) => {
		const setDate = Lib.ChanageNewDate(dt);
		// setDate.setHours(23, 59, 59);
		const now = Lib.ChanageNewDate();
		const distance = setDate.getTime() - now.getTime();

		const day = Math.floor(distance / (1000 * 60 * 60 * 24));
		const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
		const seconds = Math.floor((distance % (1000 * 60)) / 1000);

		setDay(day)
		setTimeRender(`${hours}:${minutes}:${seconds}`)

	}

	useEffect(() => {
		getDay(dt)
		timer.current = setInterval(() => getDay(dt), 1000)
		return () => clearInterval(timer.current)
	}, [dt])

	return (
		<div className={`${styles["time-box"]} mt_10`}>
			<span>열람가능 시간</span>
			<strong className="ml_10">
				<span>{`D-${day}`}</span>
				<span className="ml_5">{timeRender}</span>
			</strong>
		</div>
	)
}

// 메인 원 그래프
const MainGraph = ({ data, crdtRt, score }) => {

	const svg = useRef()

	const draw = () => {
		svg.current?.closest(".loading")?.classList.remove("loading")
		const paper = Snap(svg.current)

		const { width, height } = svg.current.getBoundingClientRect()
		const cx = width / 2
		const cy = height / 2
		const radius = width / 2 * 0.8

		const pieGroup = paper.g({ name: "pieGroup" })

		const filter = paper.filter(Snap.filter.shadow(0, 3, 6, "#000", 0.3))

		const percentage = score / 1000 * 100

		//const _crdtRt = Number(crdtRt).toFixed(0);
		//const percentage = _crdtRt;

		const angle = 240 * (Number(percentage) / 100) === 360 ? 359.9 : 240 * (Number(percentage) / 100)

		console.log(`percentage: ${percentage}`)
		console.log(`angle: ${angle}`)

		let d = Graph.describeArc(cx, cy, radius, -120, -120)

		const bgPath = paper.path(d).attr({
			stroke: "#efefef",
			strokeWidth: 10,
			fill: "none",
			strokeLinecap: "round",

		}).appendTo(pieGroup)

		const path = paper.path(d).attr({
			stroke: "#298CFA",
			strokeWidth: 9,
			fill: "none",
			strokeLinecap: "round",

		}).appendTo(pieGroup)

		bgPath.attr("d", Graph.describeArc(cx, cy, radius, -120, 120))

		const circle2 = pieGroup.circle(cx, cy, 0).attr({
			fill: "white",
			filter: filter
		})

		// setTimeout(() => {
		// 	circle2.animate({
		// 		r: width / 2 * 0.63
		// 	}, 500, window.mina.backout)
		// }, 1500)

		// setTimeout(() => {
		// 	circle1.animate({
		// 		r: width / 2 * 0.85
		// 	}, 500, window.mina.backout)
		// }, 1500)

		setTimeout(() => {
			circle2.animate({
				r: width / 2 * 0.63
			}, 500, window.mina.backout)
		}, 1500)

		let ease = window.mina.backout
		if (data > 90) ease = window.mina.easeout

		//path.attr("d", Graph.describeArc(cx, cy, radius, -120, ( 3 - 120 )))

		setTimeout(() => {
			Snap.animate(0, angle, value => {
				path.attr("d", Graph.describeArc(cx, cy, radius, -120, (value - 120)))
			}, 700, ease)
		}, 2100)

		const text = paper.text(cx, cy, [score, "점", `상위 ${crdtRt}%`]).attr({
			fill: "#298CFA",
			fontSize: "3rem",
			textAnchor: "middle",
			alignmentBaseline: "middle",
			fontWeight: 600,
			opacity: 0
		})

		text.children()[1].attr({
			fill: "#333",
			dx: 2,
			fontWeight: 500,
			fontSize: "1.6rem"
		})

		text.children()[2].attr({
			fill: "#fff",
			x: cx,
			dy: 27,
			fontWeight: 600,
			fontSize: "1.4rem"
		})

		setTimeout(() => {
			const bbox = text.getBBox()
			text.animate({
				y: bbox.cy,
				opacity: 1
			}, 500, window.mina.easeinout)
		}, 3000)

		const text_v2 = paper.text(cx, cy, "0").attr({
			fill: "#333",
			fontSize: "1.2rem",
			fontWeight: 400,
		})

		const text_v3 = paper.text(cx, cy, "1000").attr({
			fill: "#333",
			fontSize: "1.2rem",
			fontWeight: 400,
		})

		text_v2.attr({
			x: '3rem',
			y: '17.5rem'
		})

		text_v3.attr({
			x: '17rem',
			y: '17.5rem'
		})

		const rect = pieGroup.rect('50%', "50%", 75, 25, 12, 12).attr({
			transform: "translate(-35.5, 10)",
			fill: "#298CFA",
			opacity: 0
		});

		setTimeout(() => {
			rect.animate({
				opacity: 1,
			}, 500, window.mina.backout)
		}, 3000)
	}

	useEffectAvailable(draw, [data])

	return (
		<div className="mt_30 loading" style={{ width: "21.5rem", height: "21.5rem" }}>
			<svg ref={svg} style={{ height: "100%", width: "100%" }} />
		</div >
	)
}

export default DataDetail
